import { Component } from '@angular/core';
import { SUPPORT_EMAIL, SUPPORT_PHONE } from '@lsq-frontend/common-ui';

@Component({
    selector: 'trouble-signing-in-modal',
    template: `
        <div class="modal-body">
            <p class="body" [style.marginBottom]="'2rem'">
                If you no longer have access to the mobile phone number we have on file, please
                contact Customer Support for assistance:
            </p>
            <data-card>
                <p class="body">
                    Email: <a [href]="supportEmailMailTo">{{ supportEmail }}</a>
                </p>
                <p class="body">Phone: {{ supportPhone }}</p>
            </data-card>
        </div>
    `
})
export class TroubleSigningInModalComponent {
    public readonly supportEmail = SUPPORT_EMAIL;
    public readonly supportEmailMailTo = `mailto:${SUPPORT_EMAIL}`;
    public readonly supportPhone = SUPPORT_PHONE;
}
